"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPoetryInstalled = exports.extractPoetryVersion = void 0;
const debugLib = require("debug");
const child_process_1 = require("@snyk/child-process");
const debug = debugLib('snyk-fix:poetry');
function extractPoetryVersion(stdout) {
    /* stdout example:
     * Poetry version 1.1.4
     */
    let version = null;
    const re = new RegExp(/^Poetry\sversion\s([0-9.]+)/, 'g');
    const match = re.exec(stdout);
    if (match) {
        version = match[1];
    }
    return version;
}
exports.extractPoetryVersion = extractPoetryVersion;
async function isPoetryInstalled() {
    let res;
    try {
        res = await (0, child_process_1.execute)('poetry', ['--version'], {});
    }
    catch (e) {
        debug('Execute failed with', e);
        res = e;
    }
    if (res.exitCode !== 0) {
        throw res.error;
    }
    return { version: extractPoetryVersion(res.stdout) };
}
exports.isPoetryInstalled = isPoetryInstalled;
//# sourceMappingURL=check-poetry-is-installed.js.map